import {EIcons, EIconType} from "../ui/icons.model"

export interface IDragAndDropColumn {
	name: string
	label: string
	width: string
	justify: 'left' | 'center' | 'right'
	hide: boolean
	isPill: boolean
	transform: (values: any) => any
	cssVariables: (values: any) => string
	values: Array<any>,
}

export interface IDragAndDropColumnStructure {
	name: string
	label: string
	width?: string
	justify?: 'left' | 'center' | 'right'
	hide?: boolean
	isPill?: boolean
	transform?: (values: any) => any,
	cssVariables?: (value: any) => Record<string, string>
}

export interface IAddDragAndDropColumnToColumns<T> {
	columnsStructure: Array<IDragAndDropColumnStructure>
	dataStructure: Array<T>
	actions: Array<IDragAndDropColumnActions>
}

export interface IDragAndDropFilterColumns {
	mode: EDragAndDropFilterColumns
	valueToFilter?: Array<string>
}

export interface IMenuActions {
	title: string
	icon: EIcons
	action: string
	iconType?: EIconType
}

export interface IDragAndDropColumnActions {
	label: string
	icon: EIcons
	actionType: EDragAndDropColumnActionType
	showWhen: (dataStructure: any) => boolean
	classColor?: string
}

export enum EDragAndDropColumnActionType {
	edit = 'edit',
	delete = 'delete',
	view = 'view',
	redirect_form = 'redirect_form',
	confirm = 'confirm',
	cancel = 'cancel',
	copy = 'copy',
	download = 'download'
}

export interface IDragAndDropColumnActionsEmitted {
	action: IDragAndDropColumnActions
	object: any
}

export enum EDragAndDropFilterColumns {
	filter = 'filter',
	reset = 'reset',
}
